"use client";

import Image from "next/image";

const ImportanceOfGoodOralHealth: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[250px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          The Importance Of Good Oral Health
        </h2>

        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
            Taking care of your smile does more than keep your teeth and gums in
            optimal condition; good oral health also supports systemic health.
            In addition to being the leading cause of tooth loss in adults,
            researchers are finding more and more links between periodontal
            disease and a number of medical problems, including heart disease,
            stroke, diabetes, and respiratory problems. <br />
            At the office of <b>smile4me</b>, we emphasize the importance of
            prevention, early detection, and timely treatment of periodontal
            disease. We provide patients the guidance, support, and care
            required to maintain optimal periodontal health.
          </p>

          <div className="w-full lg:w-[300px] xl:w-[360px] flex-shrink-0">
            <Image
              src="/images/system_images_services_dental_interior_periodontal_treatment_periodontal_treatment1.webp"
              alt="The Importance Of Good Oral Health"
              width={360}
              height={240}
              className="rounded-lg object-cover w-full h-auto"
            />
          </div>
        </div>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
          What is gingivitis?
        </h3>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Gingivitis represents the initial stage of gum disease. Although it
          doesn’t cause overt discomfort and often goes unnoticed, there are
          specific signs to be aware of that indicate the start of a problem. If
          you notice your gums bleed when you brush, look red and inflamed, or
          feel a little tender, you more than likely have gingivitis.
        </p>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          The good news is that by treating gingivitis early, the tissue damage
          associated with more advanced stages of gum disease can be avoided.
          Despite the presence of inflammation, the overall integrity of the
          periodontal tissues in this stage remains intact.
        </p>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Treatment instituted at this point is often sufficient to reverse the
          course of the disease and to avoid any permanent damage to the
          periodontal tissues. A series of deep dental cleanings, an improved
          home care regimen and a commitment to regular maintenance may be all
          that is required to prevent this stage of periodontal disease from
          progressing.
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
          What is Periodontitis?
        </h3>

        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
            When left untreated, a case of gingivitis develops into a more
            advanced and damaging stage of gum disease, known as periodontitis.
            At this point, the connective tissue and bone that hold the teeth in
            place begin to break down. With the progression of periodontal
            disease and periodontitis, more and more tissue loss ensues. Damage
            often includes an increase in pocketing between the teeth and bone,
            gum recession, and bone loss. As unresolved periodontitis goes from
            mild to moderate to severe, it increasingly compromises the soft and
            hard tissues supporting the teeth.
          </p>

          <div className="w-full lg:w-[300px] xl:w-[360px] flex-shrink-0">
            <Image
              src="/images/system_images_services_dental_interior_periodontal_treatment_periodontal_treatment2.webp"
              alt="What is Periodontitis?"
              width={360}
              height={240}
              className="rounded-lg object-cover w-full h-auto"
            />
          </div>
        </div>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Periodontal treatment in this phase is designed to halt the
          progression of the disease and to restore tooth support as possible.
          Treatment may involve medications to control the bacteria and reduce
          the size of the pockets between the teeth and gums, gum surgery, as
          well as bone and tissue grafts.
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
          Let Us Help You Maintain Optimal Periodontal Health
        </h3>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          At the office of smile4me, we offer personalized, state-of-the-art
          solutions to help you maintain healthy gums and an attractive,
          well-functioning smile. As skilled providers of care, we utilize
          leading-edge technology and treatment methods to address a broad range
          of periodontal conditions and needs.
        </p>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Thanks to advances in care, periodontal treatment today not only helps
          to halt the progression of gum disease but also delivers effective
          solutions, including bone grafting and regenerative procedures to
          repair tissue damage, restore bone volume, improve cosmetics, or
          provide adequate support for the placement of dental implants.
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
          How is gum disease treated?
        </h3>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          The type of periodontal treatment you receive depends on several
          factors including the stage of periodontal disease, the extent of
          tissue damage, your overall oral health, existing medical conditions,
          and other considerations in care. After a thorough assessment of your
          case, we’ll discuss your options to reestablish and maintain optimal
          periodontal health. We welcome your questions and are always on hand
          to provide guidance and address your concerns.
        </p>
      </div>
    </section>
  );
};

export default ImportanceOfGoodOralHealth;
